// extracted by mini-css-extract-plugin
module.exports = {"container-share":"lbNawO_r","btn-share":"WTFPh_ga","title":"__9CcPZ6h7","socmed-icon":"__9W2IdEWI","nameSosmed":"m7VZG__X"};